function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-positions-state_svg__filter0_d_961:34)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 49,
  width: 166,
  height: 45,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#F78757",
  d: "M16 54h60v10H16z"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 55.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 55.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 67,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 51.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 55.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 55.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__b)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 67,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 51.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref0 = /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 55.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref1 = /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 55.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__c)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 67,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 51.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#3FBA5F",
  d: "M16 79h60v10H16z"
});
var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 83.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 83.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref14 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__d)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 95,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97.5,
  cy: 79.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 83.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 83.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__e)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 95,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112.5,
  cy: 79.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 83.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 83.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref20 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__f)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 95,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127.5,
  cy: 79.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 142.5,
  cy: 83.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 142.5,
  cy: 83.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref23 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__g)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 142.5,
  cy: 95,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142.5,
  cy: 79.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 157.5,
  cy: 83.5,
  r: 12.5,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 157.5,
  cy: 83.5,
  r: 11.5,
  fill: "#DBDFE5"
});
var _ref26 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-positions-state_svg__h)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 157.5,
  cy: 95,
  r: 11.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157.5,
  cy: 79.841,
  r: 5.662,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-positions-state_svg__filter0_d_961:34",
  x: 3,
  y: 43,
  width: 182,
  height: 61,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_961:34"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_961:34",
  result: "shape"
})));
function SvgEmptyPositionsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 44,
    width: 23,
    height: 23
  }, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 44,
    width: 23,
    height: 23
  }, _ref8), _ref9, _ref0, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 44,
    width: 23,
    height: 23
  }, _ref1), _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 72,
    width: 23,
    height: 23
  }, _ref13), _ref14, _ref15, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 72,
    width: 23,
    height: 23
  }, _ref16), _ref17, _ref18, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__f",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 72,
    width: 23,
    height: 23
  }, _ref19), _ref20, _ref21, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__g",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 72,
    width: 23,
    height: 23
  }, _ref22), _ref23, _ref24, /*#__PURE__*/React.createElement("mask", {
    id: "empty-positions-state_svg__h",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 72,
    width: 23,
    height: 23
  }, _ref25), _ref26, _ref27);
}
export default SvgEmptyPositionsState;